export function loadFromStorage(key: string): Record<string, any> {
  const json = localStorage.getItem(key);
  try {
    return JSON.parse(json) || {};
  } catch (error) {
    return {};
  }
}

export function saveToStorage(key: string, value: any): void {
  localStorage.setItem(key, JSON.stringify(value));
}

export function updateStorage(key: string, value: any): void {
  const old = loadFromStorage(key);
  saveToStorage(key, { ...old, ...value });
}
